<div class="modal" [class.modal-page]="applyModalPage" *ngIf="isModalOpened">
  <div
    class="modal-content"
    [class.modal-page]="applyModalPage"
    [class.edit-close-icon]="editCloseIcon"
    [class.rtl]="layoutService.websiteDirection$.value === 'rtl'"
    [style.max-width.px]="maxWidth"
    [style.padding.px]="padding"
    [style.background-color]="backgroundColor"
    [ngClass]="{'content-full-screen': contentFillTheScreen}"
  >
    <div class="modal-header" [ngClass]="{'modal-header': applyHeaderStyle }" *ngIf="title || subTitle">
      <div class="flex align-center justify-space-between">
        <div class="modal-header-title flex align-baseline" [style.color]="textColor">
          <span>{{title}}</span>
          <span *ngIf="subTitle" class="model-header-sub-title">{{subTitle}}</span>
        </div>
        <mat-icon class="modal-header-close-icon icon--small" (click)="closeCurrentModal()">close</mat-icon>
      </div>
      <mat-divider class="my-3"></mat-divider>
    </div>
    <div class="modal-body">
      <ng-content></ng-content>
      <!-- <app-icon
      class="modal__icon icon--smaller"
      (click)="closeCurrentModal()"
      [style.fill]="textColor"
      [src]="closeIconPath">
      </app-icon> -->
      <mat-icon *ngIf="!title && !subTitle && closable" type="button" class="modal__icon icon--small" (click)="closeCurrentModal()" [ngStyle]="{color: iconColor}">close</mat-icon>
    </div>
  </div>
</div>
